/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const heart_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12 21.5-9.59-9.907A5.6 5.6 0 0 1 .823 8.52a5.571 5.571 0 0 1 .527-3.413 5.632 5.632 0 0 1 1.713-2.014 5.723 5.723 0 0 1 5.103-.82 5.681 5.681 0 0 1 2.268 1.374L12 5.196l1.565-1.55a5.683 5.683 0 0 1 2.269-1.374 5.726 5.726 0 0 1 5.104.82 5.634 5.634 0 0 1 1.713 2.014v0a5.575 5.575 0 0 1 .526 3.414 5.604 5.604 0 0 1-1.589 3.073L12 21.5Z"
    />
  </svg>
)
export default heart_medium
